import { Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';

import { useFinanceFilter } from '@/hooks/filters/finance-filter.hook';
import { getFinanceCalculationDebounce } from '@/services/used-cars/used-cars.service';

import { PriceFormat } from '../../../../price-format/price-format';


import styles from './finance-footer.module.scss';

export const FinanceFooter: React.FC = () => {
  const {
    financeFilter,
    financeCalculation,
    setFinanceCalculation,
    activeBalloonOption,
  } = useFinanceFilter();

  useEffect(() => {
    getFinanceCalculationDebounce(
      financeFilter,
      setFinanceCalculation,
      activeBalloonOption
    );
  }, [financeFilter]);

  return (
    <div className={styles.financeFooter}>
      <div className={styles.financeFooterTotal}>
        <Text className={styles.financeFooterTitle}>Total Repayment</Text>
        <div className={styles.totalWrapper}>
          <Text className={styles.financeFooterValue}>
            <PriceFormat value={financeCalculation.totalRepayment} prefix="R" />
          </Text>
          <Text className={styles.vatTextMobile}>inclusive of VAT at 15%</Text>
        </div>
        <Text className={styles.vatText}>inclusive of VAT at 15%</Text>
      </div>
      <div className={styles.financeFooterMonthly}>
        <div className={styles.financeFooterMonthlyTextWrapper}>
          <Text className={styles.financeFooterTitle}>Monthly Repayment</Text>
          <Text className={styles.financeFooterValue}>
            <PriceFormat value={financeCalculation.monthlyPayment} prefix="R" />
          </Text>
          <Text className={styles.financeFooterPerMonth}>per month</Text>
        </div>
      </div>
    </div>
  );
};
